<div class="phx-alert animate-fade-up" [ngClass]="getClass()">
    <div class="container phx-alert-container">
        <div *ngIf="alert.title">
            <div class="row">
                <div class="col-1">
                    <div class="fa-solid phx-share-list-alert-check" [ngClass]="getFontAwesomeIcon()"></div>
                </div>
                <div class="col-10 fw-bold">
                    <span [innerHTML]="alertTitle"></span>
                </div>
                <button type="button" [attr.aria-label]="'cart.button.close'| translate" class="fa-solid fa-xmark phx-share-list-alert-close close col-1" (click)="closeAlert()"></button>
            </div>
            <div class="row">
                <div class="col-1"></div>
                <div class="col-10">
                    <span [innerHTML]="alertMessage"></span>
                </div>
                <div class="col-1"></div>
            </div>
            <div class="row">
                <div class="col-1"></div>
                <div class="col-10">
                    <customer-service *ngIf="alert.showCustomerServiceNumber"></customer-service>
                </div>
            </div>
            <ng-container *ngTemplateOutlet="shareListLink"></ng-container>
        </div>
        <div *ngIf="!alert.title">
            <div class="row">
                <div class="col-1">
                    <div class="fa-solid phx-share-list-alert-check" [ngClass]="getFontAwesomeIcon()"></div>
                </div>
                <div class="col-10">
                    <span [innerHTML]="alertMessage"></span>
                </div>
                <button type="button" [attr.aria-label]="'cart.button.close'| translate" class="fa-solid fa-xmark phx-share-list-alert-close close" (click)="closeAlert()"></button>
            </div>
            <div class="row">
                <div class="col-1"></div>
                <div class="col-10">
                    <customer-service *ngIf="alert.showCustomerServiceNumber"></customer-service>
                </div>
            </div>
            <ng-container *ngTemplateOutlet="shareListLink"></ng-container>
        </div>
    </div>
</div>

<ng-template #shareListLink>
    <div class="row" *ngIf="alert.alertType === 'share-list'">
        <div class="col-1"></div>
        <div class="col-10">
            <a (click)="closeAlert()" [routerLink]="SHARE_LIST_ROUTE">
                <span translate="cart.manage.share.lists"></span>
            </a>
        </div>
        <div class="col-1"></div>
    </div>
</ng-template>
